<template>
    <div class="wrap-content activity-dashboard-page">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-4 title-detail filter-title-section">
                    <h2>Activity Dashboard</h2>
                </div>

                <div class="col-md-8 d-none-print">
                    <div class="row">
                        <div class="col-md-4 col-xs-12">
                            <div class="form-group custom-datepicker">
                                <date-picker
                                    ref="start date"
                                    v-model="query.startDate"
                                    v-validate="{
                                        required: true,
                                        date_format: 'dd/MM/yyyy',
                                        before: 'end date',
                                    }"
                                    name="start date"
                                    class="form-control"
                                    value-type="format"
                                    format="DD/MM/YYYY"
                                    :class="{
                                        'is-invalid': errors.has('start date'),
                                    }"
                                    lang="en"
                                ></date-picker>
                                <i
                                    :class="[
                                        {
                                            'disable-input': false,
                                        },
                                        'icon-calendar',
                                    ]"
                                ></i>
                            </div>
                        </div>
                        <div class="col-md-4 col-xs-12">
                            <div class="form-group custom-datepicker">
                                <date-picker
                                    ref="end date"
                                    v-model="query.endDate"
                                    v-validate="{
                                        required: true,
                                        date_format: 'dd/MM/yyyy',
                                    }"
                                    name="end date"
                                    class="form-control"
                                    value-type="format"
                                    format="DD/MM/YYYY"
                                    :class="{
                                        'is-invalid': errors.has('end date'),
                                    }"
                                    lang="en"
                                ></date-picker>
                                <i
                                    :class="[
                                        {
                                            'disable-input': false,
                                        },
                                        'icon-calendar',
                                    ]"
                                ></i>
                            </div>
                        </div>
                        <div class="col-md-4 col-xs-12">
                            <div class="row">
                                <div
                                    :class="{
                                        'col-md-12': !hasScopes(
                                            'export-activity-dashboard'
                                        ),
                                        'col-md-5': hasScopes(
                                            'export-activity-dashboard'
                                        ),
                                    }"
                                >
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                        :class="loading ? 'disabled' : ''"
                                        @click="apply"
                                    >
                                        <span class="btn-text">Apply</span>
                                        <span class="loader"></span>
                                    </button>
                                </div>
                                <div
                                    v-if="
                                        hasScopes('export-activity-dashboard')
                                    "
                                    class="col-xs-12 col-md-7"
                                >
                                    <base-button
                                        v-b-modal.export-report-popup
                                        btn-label="Export"
                                        btn-type="submit"
                                        btn-variant="secondary"
                                    ></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div id="activity-charts" class="col-md-12">
                <!-- on boarder count starts -->
                <div class="row stastics-section">
                    <graph-stats
                        v-for="stats in statsList"
                        :key="stats.path"
                        :title="stats.title"
                        :path="stats.path"
                        :query="query"
                        :reset="reset"
                    ></graph-stats>
                    <graph-stats
                        title="AVG. ONBOARDING LENGTH"
                        path="insights/customers/avg-onboarding"
                        :query="query"
                        :icon="true"
                        :reset="reset"
                    ></graph-stats>
                </div>
                <!-- on boarder count ends -->
                <div class="row">
                    <div class="col-xs-12 col-md-12">
                        <!-- activity timeline dashboard chart -->
                        <!-- Line Graph -->
                        <line-graph
                            id="activity-timeline-report"
                            path="insights/customers/activity-timeline"
                            :query="query"
                            :reset="reset"
                            graph-heading="Activity Timeline"
                        ></line-graph>
                        <!-- activity timeline dashboard chart end-->
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-6 mb-50-print">
                        <div class="card dashboard-card sm-radius">
                            <!-- dashboard alerts report -->

                            <!-- Column Graph -->
                            <column-graph
                                id="screening-by-type"
                                path="insights/kyc-alerts-screening-type"
                                :query="query"
                                :reset="reset"
                                graph-heading="KYC Alerts by Screening Type"
                                class="mb-15-print"
                            ></column-graph>
                        </div>
                    </div>
                    <div
                        class="col-xs-12
                               col-md-6"
                    >
                        <div class="card dashboard-card sm-radius">
                            <!-- screening hit by type report -->
                            <donut-graph
                                id="alerts-by-type"
                                path="insights/kyc-alerts"
                                :query="query"
                                legend-id="alert-types-legend"
                                :reset="reset"
                                graph-heading="KYC Alerts by Alert Type"
                            >
                            </donut-graph>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div
                        class="col-xs-12 
                        col-md-6
                        mb-450-print"
                    >
                        <div class="card dashboard-card sm-radius ">
                            <donut-graph
                                id="screen-hit-by-type"
                                path="insights/name-screening-hits"
                                :query="query"
                                legend-id="screenHitByTypeLegend"
                                :reset="reset"
                                graph-heading="Name Screening Hit by Type"
                            >
                            </donut-graph>
                        </div>
                    </div>
                    <div
                        class="col-xs-12 
                        col-md-6"
                    >
                        <div class="card dashboard-card sm-radius">
                            <!-- dashboard alerts report -->

                            <donut-graph
                                id="on-board-issue"
                                path="insights/on-boarding-alerts"
                                :query="query"
                                legend-id="onBoardIssueLegend"
                                :reset="reset"
                                graph-heading="Customer Onboarding With / Without Alert"
                            >
                            </donut-graph>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-md-6 aging-alert-chart">
                        <div class="card dashboard-card sm-radius">
                            <!-- dashboard alerts report -->

                            <!-- Stacked Graph -->
                            <column-stacked-graph
                                id="aging-by-alert-type"
                                path="insights/aging-alert-type"
                                :query="query"
                                :reset="reset"
                                graph-heading="Aging by Alert Type"
                            ></column-stacked-graph>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <export-report-popup
            export-graph-id="activity-charts"
            file-name="Activity Dashboard.pdf"
            :graph-ids="graphIds"
        ></export-report-popup>
        <base-toast></base-toast>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'

require('amcharts3')
require('amcharts3/amcharts/serial')
require('amcharts3/amcharts/pie')
import { mapGetters } from 'vuex'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import exportReportPopup from '@/components/popups/ExportReportPopup.vue'
import lineGraph from '@/components/graphs/LineGraph.vue'
import columnGraph from '@/components/graphs/ColumnGraph.vue'
import donutGraph from '@/components/graphs/DonutGraph.vue'
import columnStackedGraph from '@/components/graphs/ColumnStackedGraph.vue'
import graphStats from '@/components/GraphStats.vue'

export default {
    components: {
        exportReportPopup,
        lineGraph,
        columnGraph,
        donutGraph,
        columnStackedGraph,
        graphStats,
        DatePicker,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            graphIds: [
                'activity-timeline-report',
                'alerts-by-type',
                'screening-by-type',
                'screen-hit-by-type',
                'on-board-issue',
                'aging-by-alert-type',
            ],
            reset: null,
            query: {
                startDate: this.$moment()
                    .subtract(30, 'days')
                    .format('DD/MM/YYYY'),
                endDate: this.$moment().format('DD/MM/YYYY'),
            },
            statsList: [
                {
                    title: 'Customers Onboarded',
                    path: 'insights/customers/on-boarded-count',
                },
                {
                    title: 'Verification Pending',
                    path: 'insights/customers/on-boarded-count?status=pending',
                },
                {
                    title: 'APPROVED',
                    path: 'insights/customers/on-boarded-count?status=approved',
                },
                {
                    title: 'REJECTED',
                    path: 'insights/customers/on-boarded-count?status=rejected',
                },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'hasScopes']),
        // maxStartDate() {
        //     alert(this.query.endDate)
        //     return this.$moment(this.query.endDate).format('MM/DD/YYYY')
        // },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async apply() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    this.reset = new Date().getTime()
                    // this.$store.commit('setLoading', true)
                } catch (error) {
                    // console.log(error)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of apply() method
    }, // End of Component > methods
} // End of export default
</script>
